var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexrow"},[_c('people-avatar',{staticClass:"flexrow-item",attrs:{"no-cache":true,"person":_vm.item,"size":30}}),_c('span',{staticClass:"flexrow-item"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }